import Vue from "vue";
import { Component } from "vue-property-decorator";

import { ClientNotifier } from "../../scripts/ah.mb.client-notifications";
import { DbAdminServices } from "../../scripts/ah.mb.dbadmin-services";
import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

import { bootbox } from "../../infrastructure/bootbox-shim";

@Component
export default class TagCategories extends Vue {

    services = new DbAdminServices();

    // Create user notifier
    userNotifier = new ClientNotifier();

    table = null;

    mounted() {

        this.populateTable();

    };


    // Refresh
    refreshTable() {
        this.table.ajax.reload();
    };


    addTagCategory() {
        bootbox.prompt({
            title: `Add Tag`,
            content: "",
            callback: tag => {

                if (tag) {
                    {
                        bootbox.prompt({
                            title: `Add Tag Category`,
                            content: "",
                            callback: category => {

                                if (category) {

                                    const payload = { tag: tag, category: category };

                                    FetchWrapper.sendCommandAndHandle("/api/1.0/tagcategories/settagcategory",
                                        {
                                            method: "post",
                                            body: JSON.stringify(payload)
                                        })
                                        .then(response => {
                                            bootbox.alert(response.response, () => { });
                                            if (response.success)
                                                this.refreshTable();
                                        });
                                }
                            }
                        })

                    }
                }
            }
        })
    }

    // Script list drawer
    populateTable() {
        const url = "/tagcategories/indexasdt"; //  "@Url.Action("IndexAsDt", "TagCategories")";

        // Because mvc datatables expects variables in the old format we have to set
        // it to specifically use the old variables, because we are using ajax option below

        const columns: DataTables.ColumnSettings[] = [
            {
                title: "Tag",
                data: "tag",
            },
            {
                title: "Category",
                data: "category",

            },
            {
                title: "Options",
                orderable: false,
                searchable: false,
                width: "12%",

                render: (data, type, oObj) => {
                    const itemId = oObj.tag;
                    const category = oObj.category;

                    const editTagBtn =
                        `<a class="btn btn-sm btn-default edit-tag-button" data-category="${category}" data-tag="${itemId}">Edit Category</a>`;

                    const deleteTagBtn =
                        `<a class="btn btn-sm btn-warning delete-tag-button" data-tag="${itemId}">Delete</a>`;


                    return `<div class="btn-toolbar">${editTagBtn}${deleteTagBtn}</div>`;
                }
            }
        ];

        this.table = $("#tag-categories-table")
            .DataTable({
                processing: false,
                serverSide: true,

                ajax: {
                    type: "POST",
                    url: url,
                    error: (reason) => {
                        //console.log(reason);
                        bootbox.alert(`Error retreiving list: ${reason.statusText}`,
                            () => { });
                    }
                },


                autoWidth: true,
                stateSave: false,
                order: [1, "asc"],
                searching: true,
                paging: true,
                pageLength: 15,

                // Draw callback, for attaching button handlers
                drawCallback: this.tableDrawCallback,

                columns: columns

            });


    };

    // Table draw callback
    tableDrawCallback() {
        $(".delete-tag-button")
            .click((e => {

                var objectId = $(e.currentTarget).attr("data-tag");
                var tag = objectId.toString();
                bootbox.confirm(`Delete tag "${tag}"?`,
                    result => {
                        if (result) {

                            const payload = { tag: tag };
                            FetchWrapper.sendCommandAndHandle("/api/1.0/tagcategories/delete",
                                { method: "post", body: JSON.stringify(payload) })
                                .then(response => {
                                    bootbox.alert(response.response, () => { });

                                    if (response.success)
                                        this.refreshTable();
                                });
                        }
                    });
                return false;
            }));

        // Change password button handler
        $(".edit-tag-button")
            .click(e => {
                e.preventDefault();
                var tag = $(e.currentTarget).attr("data-tag");
                var category = $(e.currentTarget).attr("data-category");

                bootbox.prompt({
                    title: `Set category for ${tag}`,
                    content: category,
                    callback: data => {

                        if (data) {
                            {
                                const payload = { tag: tag, category: data };

                                FetchWrapper.sendCommandAndHandle("/api/1.0/tagcategories/settagcategory",
                                    {
                                        method: "post",
                                        body: JSON.stringify(payload)
                                    })
                                    .then(response => {
                                        bootbox.alert(response.response, () => { });
                                        if (response.success)
                                            this.refreshTable();
                                    });
                            }
                        }
                    }
                });

            });


    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/tag-categories/tag-categories.ts